import { animate, animation, style, transition, trigger, useAnimation } from '@angular/animations';
import { BRM_PUBLIC_PAGE_CONFIG } from './charglink-brm-public.config';

/**
 * The public ranking page's animations (ST-2696). The values come from the config file; this file
 * only says how they animate, so the component keeps the logic and none of the animation code.
 */

const { pageTransition, boxEnterLeave, emptySwap } = BRM_PUBLIC_PAGE_CONFIG.animation;

// 'none' runs for 0 ms instead of disabling the trigger, so the boxes inside the page still animate.
const pageMs = pageTransition.type === 'none' ? 0 : pageTransition.durationMs;
const pageEnterX = pageTransition.type === 'slide' ? '100%' : '0';
const pageLeaveX = pageTransition.type === 'slide' ? '-100%' : '0';
const pageOpacity = pageTransition.type === 'fade' ? 0 : 1;

/** Rises from `offset` px and fades in. Shared by the battery box and the empty-message swap. */
const riseIn = animation([
	style({ transform: 'translateY({{offset}}px)', opacity: 0 }),
	animate('{{duration}}ms {{delay}}ms {{easing}}', style({ transform: 'translateY(0)', opacity: 1 })),
]);

export const pageTransitionAnimation = trigger('pageTransition', [
	transition(':enter', [
		style({ transform: `translateX(${pageEnterX})`, opacity: pageOpacity }),
		animate(`${pageMs}ms ${pageTransition.easing}`, style({ transform: 'translateX(0)', opacity: 1 })),
	]),
	transition(':leave', [
		animate(`${pageMs}ms ${pageTransition.easing}`, style({ transform: `translateX(${pageLeaveX})`, opacity: pageOpacity })),
	]),
]);

export const readyBoxAnimation = trigger('readyBox', [
	transition(':enter', useAnimation(riseIn, { params: {
		offset: boxEnterLeave.offsetPx, duration: boxEnterLeave.durationMs, delay: 0, easing: boxEnterLeave.easing,
	} })),
	transition(':leave', animate(`${boxEnterLeave.durationMs}ms ${boxEnterLeave.easing}`, style({ opacity: 0, height: 0 }))),
]);

export const emptySwapAnimation = trigger('emptySwap', [
	transition(':enter', useAnimation(riseIn, { params: {
		offset: emptySwap.offsetPx, duration: emptySwap.durationMs, delay: emptySwap.enterDelayMs, easing: emptySwap.easing,
	} })),
	transition(':leave', animate(`${emptySwap.durationMs}ms ${emptySwap.easing}`,
		style({ transform: `translateY(${emptySwap.offsetPx}px)`, opacity: 0 }))),
]);

export const BRM_PUBLIC_PAGE_ANIMATIONS = [pageTransitionAnimation, readyBoxAnimation, emptySwapAnimation];
